import * as funcs from '../../utils/funcs';

//const _URL = 'http://localhost:61655/api/v1/crm/';
const _URL = 'https://apicrm.bndv.com.br/api/v1/crm/';

export const services = {
    listaMercadoLivreCreditosPreAprovados: (authorizationToken, pDTO) => {
        var query = funcs.encodeURI(pDTO);

        return new Request(_URL + 'listaMercadoLivreCreditoPreAprovado',
            {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'Authorization': 'Bearer ' + authorizationToken
                },
                body: query
            });
    },
    obterMercadoLivreCreditoPreAprovado: (authorizationToken, id) => {
        return new Request(_URL + 'obterMercadoLivreCreditoPreAprovado?id=' + id.toString(),
            {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'Authorization': 'Bearer ' + authorizationToken
                }
            });
    }
}